import React, { useEffect, useMemo } from 'react'
import { Col, Divider, Form, Row } from 'antd'
import PropTypes from 'prop-types'

import { GridFormItem } from '../../../core/components/sections'

import {
  FormButtons,
  FormTreeSelect,
} from '../../../common/components/sections'
import { StyledPaddingTopCol } from '../../../common/components/styled'
import { PERMISSIONS } from '../../../common/constants'
import { useFormDirty } from '../../../common/hooks'
import { treeOptionPropType } from '../../../common/prop-types'

import { menuCurationTaskPropType } from '../../prop-types'
import { MenuCurationTaskDuplicateButton } from '../sections'

import { menuCurationTaskEditorFormInitialValues } from './initial-values'

const MenuCurationTaskEditorForm = ({
  menuCurationTask,
  cuisineTypeOptions,
  isLoading,
  isDisabled,
  onSubmit,
}) => {
  const [form] = Form.useForm()
  const { isDirty, setToDirty, resetForm } = useFormDirty(form)

  const initialValues = useMemo(
    () => menuCurationTaskEditorFormInitialValues(menuCurationTask),
    [menuCurationTask],
  )

  useEffect(() => {
    resetForm()
  }, [initialValues, resetForm])

  return (
    <Form
      form={form}
      initialValues={initialValues}
      name="editMenuCurationTask"
      onFinish={onSubmit}
      autoComplete="off"
      onFieldsChange={setToDirty}
    >
      <Row gutter={[16]}>
        <Col span={6}>
          <FormTreeSelect
            label="Cuisine Type"
            labelAbove
            showSearch
            name="cuisineTypeId"
            treeData={cuisineTypeOptions}
            placeholder="Select Cuisine Type..."
            disabled={isDisabled}
          />
        </Col>
        <GridFormItem span={3} label="Duplicate">
          <MenuCurationTaskDuplicateButton
            originalMenuId={menuCurationTask.menu?.originalMenuId}
          />
        </GridFormItem>
        <StyledPaddingTopCol span={6}>
          <FormButtons
            permissions={[PERMISSIONS.MENU_CURATION_TASK.UPDATE]}
            isDisabled={!isDirty}
            isLoading={isLoading}
            onReset={resetForm}
          />
        </StyledPaddingTopCol>
      </Row>
      <Divider />
    </Form>
  )
}

MenuCurationTaskEditorForm.propTypes = {
  menuCurationTask: menuCurationTaskPropType.isRequired,
  cuisineTypeOptions: PropTypes.arrayOf(treeOptionPropType),
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

MenuCurationTaskEditorForm.defaultProps = {
  cuisineTypeOptions: [],
  isLoading: false,
  isDisabled: false,
}

export default MenuCurationTaskEditorForm
